export default angular.module('ArticlesSummary', ['articles_factories']);